<template>
  <div class="app-main-content financial-report">
    <div class="details-view">
      <div class="main-content">
        <span style="position: absolute; right: 10px; margin-top: 5px;z-index: 9999">
          <el-link :type="lbAccountType" no="lbAccount" @click="selectAccountSetHandler">{{ lbAccount }}</el-link>
        </span>
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width:100%;" @tab-click="handleTabClick">
            <el-tab-pane :label="$t('CargoMsg.Cargo_BalanceSheet')" name="balanceSheet">
              <!-- 对应 cargoware的 BalanceSheetStatement -->
              <balance-sheet-statement ref="balanceSheet" key="balanceSheet" :account-set="accountSet" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_ProfitLoss')" name="profitLoss">
              <!-- 对应 cargoware的 IncomeStatementView -->
              <income-statement-view ref="profitLoss" key="profitLoss" :account-set="accountSet" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_BalanceSheetQuarter')" name="balanceSheetQuarter">
              <balance-sheet-statement ref="balanceSheetQuarter" key="balanceSheetQuarter" report-type="quarter" :account-set="accountSet" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_ProfitLossQuarter')" name="profitLossQuarter">
              <income-statement-view ref="profitLossQuarter" key="profitLossQuarter" report-type="quarter" :account-set="accountSet" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_BalanceSheetYear')" name="balanceSheetYear">
              <balance-sheet-statement ref="balanceSheetYear" key="balanceSheetYear" report-type="year" :account-set="accountSet" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_ProfitLossYear')" name="profitLossYear">
              <income-statement-view ref="profitLossYear" key="profitLossYear" report-type="year" :account-set="accountSet" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <!-- 选择账套 -->
      <account-set-popup
        ref="refAccountSetPopup"
        :mode="accountSetPopup.mode"
        :visible.sync="accountSetPopup.visible"
        :load-accounting-document-type-flag="false"
        :load-mapping-departments-flag="false"
        :load-mapping-staffs-flag="false"
        :load-accounting-documents-rule-flag="false"
        :sort-fiscal-period-desc="true"
        :load-year-quarter="true"
        @cancel="()=>accountSetPopup.visible=false"
        @select="accountSetSelectHandler"
      />
    </div>
  </div>
</template>

<script>
import BalanceSheetStatement from '@/views/cargo/v0/FinanceManage/FinancialReport/BalanceSheetStatement'
import IncomeStatementView from '@/views/cargo/v0/FinanceManage/FinancialReport/IncomeStatementView'
import AccountSetPopup from '@/views/cargo/v0/FinanceManage/FinanceInterface/components/AccountSetPopup'
import { BSWarningUtil } from '@/class/cargo/model/utils/BSWarningUtil'

export default {
  name: 'FinancialReport',
  components: { BalanceSheetStatement, IncomeStatementView, AccountSetPopup },
  data() {
    return {
      activeTabName: 'balanceSheet',
      accountSet: null, // 当前账套
      accountSetPopup: { visible: false, mode: 'office' }
    }
  },
  computed: {
    lbAccount() {
      console.log('lbAccount', this.accountSet)
      return this.accountSet === null ? this.$t('CargoMsg.Cargo_PleaseSelectSob') : (this.$t('CargoMsg.Cargo_SetsOfBooksP') + this.accountSet.name)
    },
    lbAccountType() {
      return this.accountSet === null ? 'danger' : 'primary'
    },
    accountSets() {
      return this.$refs['refAccountSetPopup'] ? this.$refs['refAccountSetPopup'].rowData : []
    }
  },
  async mounted() {
    const allowFinanceOperation = await BSWarningUtil.checkFinanceExpire(this.$route, this.$router)
    if (!allowFinanceOperation) {
      return
    }
    if (this.accountSet === null) {
      this.selectAccountSetHandler()
    }
  },
  methods: {
    // 选择账套
    selectAccountSetHandler() {
      console.log('selectAccountSetHandler')
      this.accountSetPopup.visible = true
    },
    accountSetSelectHandler(data) {
      this.accountSet = data
      this.$nextTick(() => {
        this.$refs.balanceSheet.defaultFpUuid()
      })
    },
    handleTabClick() {
      this.$refs[this.activeTabName].defaultFpUuid()
    }
  }
}
String.prototype.format = function() {
  if (arguments.length == 0) return this
  for (var s = this, i = 0; i < arguments.length; i++) {
    s = s.replace(new RegExp('\\{' + i + '\\}', 'g'), arguments[i])
  }
  return s
}
</script>

<style scoped>

</style>
